import { useEffect, useRef, useState } from "react"

import {
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
} from "@chakra-ui/react"

import SearchIcon from "components/icons/search_icon"
import XCircleIcon from "components/icons/xcircle_icon"
import { useDebounce } from "hooks/useDebounce"

import { SearchTypeProps } from "./types"

const CustomSearch = (props: SearchTypeProps) => {
  const {
    onClear,
    setTerm,
    term,
    width = "xs",
    inputHeight = "40px",
    borderRadius = "full",
    placeHolder = "Search for...",
    placeHolderColor = "#00000077",
    isSearchIcon = true,
    debounceMs = 500,
  } = props

  const [localTerm, setLocalTerm] = useState<string>(term)
  const debouncedTerm = useDebounce(localTerm, debounceMs)
  const lastSentTermRef = useRef<string>(term)

  // Sync when parent `term` changes (e.g., cleared externally)
  useEffect(() => setLocalTerm(term), [term])

  // Update parent setTerm when debounced value changes (only if different from last sent)
  useEffect(() => {
    if (debouncedTerm !== lastSentTermRef.current) {
      setTerm(debouncedTerm)
      lastSentTermRef.current = debouncedTerm
    }
  }, [debouncedTerm, setTerm])

  return (
    <InputGroup borderColor='transparent' w={width} height='42px'>
      {isSearchIcon && (
        <InputLeftElement
          pl='8px'
          pointerEvents='none'
          fontSize='1.2em'
          h={inputHeight}
        >
          <SearchIcon fill='#9D9696' />
        </InputLeftElement>
      )}
      <Input
        placeholder={placeHolder}
        value={localTerm}
        onChange={(e) => setLocalTerm(e.target.value)}
        border='1.5px solid #e1e1e1'
        borderColor='#e1e1e1'
        borderRadius={borderRadius}
        h={inputHeight}
        bg='#fff'
        pl={isSearchIcon ? 10 : 4}
        _placeholder={{ color: placeHolderColor }}
        _focus={{
          borderColor: "secondaryColor",
          outline: "1.5px solid",
          outlineOffset: "0px",
          outlineColor: "secondaryColor",
        }}
        _hover={{}}
      />
      {term && (
        <InputRightElement h={inputHeight}>
          <IconButton
            onClick={() => {
              onClear()
              setLocalTerm("")
            }}
            aria-label='clear input'
            variant='ghost'
            icon={<XCircleIcon />}
          />
        </InputRightElement>
      )}
    </InputGroup>
  )
}

export default CustomSearch
